import cn from 'classnames';
import type { IStudentBadge } from '@/entities/Badges';
import { AppImage } from '@/shared/ui/AppImage';
import badgeEarnedArt from '@/shared/assets/images/badge-earned.svg?url';
import badgeLockedArt from '@/shared/assets/images/badge-locked.svg?url';

interface BadgeArtProps {
  badge: IStudentBadge;
  // По макету 124 в карточке и в попапе, 20 в шапке
  size?: number;
  className?: string;
}

// При пустом iconUrl рисуем макетную картинку: цветную у полученного, серую у запертого.
// ?url в импорте обязателен, иначе svgo из vite-plugin-svgr схлопнет цвета в currentColor.
export const BadgeArt = ({ badge, size = 124, className }: BadgeArtProps) => {
  // В серверной иконке состояния нет, она одна на любой бейдж. Поэтому запертый
  // глушим сами — иначе полученный и незаработанный выглядят одинаково.
  // Макетную картинку глушить не надо: для запертого она уже серая.
  const mutedServerIcon = Boolean(badge.iconUrl) && !badge.isEarned;

  return (
    <AppImage
      src={badge.iconUrl ?? (badge.isEarned ? badgeEarnedArt : badgeLockedArt)}
      fallbackImage={badge.isEarned ? badgeEarnedArt : badgeLockedArt}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={cn('object-contain', mutedServerIcon && 'opacity-60 grayscale', className)}
    />
  );
};
